'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InspiringMessage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'inspiring-message';

function InspiringMessage(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      iconAlt = _ref.iconAlt,
      content = _ref.content,
      link = _ref.link;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement('img', { src: icon, alt: iconAlt }),
    _react2.default.createElement(
      'h3',
      null,
      title
    ),
    _react2.default.createElement(
      'p',
      null,
      content
    ),
    _react2.default.createElement(
      'a',
      { href: link.href },
      link.label
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SiteFooter/InspiringMessages/InspiringMessage.jsx
// module id = 1126
// module chunks = 0